export default __webpack_public_path__ + "static/media/webpainting2.7b27a7e8.png";